import type { RoomSection } from './types';

/**
 * The section map: where the client is, what they've finished, and free movement between the two.
 *
 * FREE NAVIGATION is a hard requirement — clicking any section jumps to it regardless of completion.
 * The wizard is not a forced funnel; a client filling a long form must be able to skip ahead and
 * come back. "Complete" is a per-section marker (from the shared engine), never a lock.
 *
 * Only currently-VISIBLE sections appear — a section hidden by a condition is not a step the client
 * can be on.
 */
export function ProgressMap({
  sections,
  visibleSectionIds,
  completedSectionIds,
  currentSectionId,
  onNavigate,
}: {
  sections: RoomSection[];
  visibleSectionIds: Set<string>;
  completedSectionIds: string[];
  currentSectionId: string;
  onNavigate: (sectionId: string) => void;
}) {
  const completed = new Set(completedSectionIds);
  const visible = sections.filter((s) => visibleSectionIds.has(s.id));

  return (
    <nav className="room-progress" aria-label="מקטעי הטופס">
      <ol className="room-progress-list">
        {visible.map((section, i) => {
          const state = section.id === currentSectionId ? 'current' : completed.has(section.id) ? 'done' : 'todo';
          return (
            <li key={section.id} className="room-progress-item">
              <button
                type="button"
                className="room-progress-step"
                data-state={state}
                aria-current={state === 'current' ? 'step' : undefined}
                onClick={() => onNavigate(section.id)}
              >
                <span className="room-progress-index" aria-hidden="true">
                  {state === 'done' ? '✓' : String(i + 1).padStart(2, '0')}
                </span>
                <span className="room-progress-title">{section.title}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
